<template>

    <section
            class="dd-m-carousel dd-m-carousel--small-products dd-m-carousel--custom-dots dd-l-section dd-l-section--small-products">

        <loading type="banner" v-if="isLoading"></loading>

        <div class="dd-l-container__wrapper dd-l-container__wrapper--content" v-if="results.length">
            <div class="dd-m-carousel--products__header">
                <h2 class="dd-m-carousel--products__title">{{ title ? getTranslateString(title) : getTranslateString('Recently viewed')}}</h2>

                <span class="dd-m-helper--detail-row"></span>
            </div>

            <div class="dd-l-section--small-products__content">
                <!-- <div class="dd-m-carousel__variable-slider">
                    <Slick ref="slick" :options="slickOptions">
                        <card-small-product v-for="(item, index) in results" :item="item"
                                            :key="index"></card-small-product>
                    </Slick>
                </div> -->
                <card-small-product v-for="(item, index) in results" :item="item"
                                            :key="index"></card-small-product>
            </div>
        </div>
    </section>

</template>
<script>
    import SlickOptions from '../../providers/slick';
    import ProductService from '../../providers/api/product-service';
    import Slick from "vue-slick";
    import Loading from "../loading";
    import CardSmallProduct from "./card-small-product";

    const slickOptions = new SlickOptions(),
        productService = new ProductService();

    export default {
        name: 'list-small-products',
        components: {CardSmallProduct, Loading, Slick},
        props: ['perPage', 'title'],
        data: () => {
            return {
                results: [],
                slickOptions: slickOptions.getAssertive(true),
                isLoading: false
            }
        },
        mounted() {
            this.isLoading = true;
            productService.doGetLastSeenProducts(this.perPage)
                .then((res) => {
                    this.results = res.data.data;
                    this.isLoading = false;
                })
                .catch(() => this.isLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/list-small-products.vue